import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { SessionService } from '@core/services/session.service';
import { HeaderBalanceComponent } from './header-balance/header-balance.component';
import { GamesAreaComponent } from './header-games/header-games.component';
import { HeaderUserComponent } from './header-user/header-user.component';
import { UIService } from '@core/services/ui.service';
import { HeaderNavigationComponent } from './header-navigation/header-navigation.component';
import { ModalService } from '@core/modals/services/modal.service';
import { LoginButtonComponent } from '@core/components/login-button/login-button.component';
import { AffiliatesService } from '@features/engagement/affiliates/services/affiliates.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    SvgIconComponent,
    HeaderBalanceComponent,
    GamesAreaComponent,
    HeaderUserComponent,
    HeaderNavigationComponent,
    LoginButtonComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  public readonly affiliatesService = inject(AffiliatesService);
  public readonly sessionService = inject(SessionService);
  public readonly uiService = inject(UIService);
  public readonly modalService = inject(ModalService);
  public readonly router = inject(Router);

  handleOpenMyProfileModal() {
    this.modalService.openModal('MyProfileModal');
  }

  handleNavigate() {
    this.router.navigate(['/']);
    if (this.uiService.breakpoints().max_xl2) {
      this.uiService.isShowChat.set(false);
      this.uiService.isShowNav.set(false);
    }
  }
}
